<template>
  <section class="store" @click="navToStore">
    <div
      class="main"
      v-lazy:background-image="
        handleImg({ url: storeBg, width: 702, height: 196 })
      "
    >
      <div class="store-detail">
        <img class="store-logo" v-lazy="logo" alt="" />
        <div class="store-intro">
          <div class="store-intro-top">
            <span class="store-name">{{ storeName }}</span>
            <div class="country">
              <img v-if="false" src="" alt="" />
              <span>{{ storeCountry }}</span>
            </div>
          </div>
          <span class="sales-products-num">{{`${storeIdOnSaleNum}${$t("message.goods.hassell")}`}}</span>
        </div>
      </div>
      <div class="store-mask"></div>
      <div class="store-entrance">
        <span>{{ $t("message.goods.baguette") }}</span>
        <van-icon class="arrow" name="arrow" color="white"/>
      </div>
    </div>
  </section>
</template>
<script>
import { Icon } from 'vant';
export default {
    components: {
        [Icon.name]: Icon,
    },
    props: {
        storeBg: String,
        storeName: String,
        storeCountry: String,
        storeIdOnSaleNum: Number,
        storeId: String,
        storeLogo: String,
    },
    data() {
        return {
        };
    },
    computed: {
        logo() {
            return (
                `${this.handleImg({ url: this.storeLogo, width: 116, height: 116 })}` ||
        'https://fr-static.shopshops.top/20200328/dianpulogo.f2fb5760d3e67c86.png'
            );
        },
    },
    methods: {
        navToStore() {
          if (this.storeId) {
                this.$router.push({
                    path: '/store',
                    query: {
                        storeId: this.storeId,
                    },
                })
          }
        },
    },
};
</script>
<style lang="less" scoped>
img {
  display: block;
}
i {
  color: #a4a4a4;
}
.store {
  padding: 12px;
  font-family: "TradeGothicLT";
  .main {
    position: relative;
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 98px;
    padding: 12px;
    border-radius: 8px;
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
    .store-mask {
      position: absolute;
      top: 0;
      left: 0;
      z-index: 0;
      width: 100%;
      height: 100%;
      background-color: #000;
      opacity: .35;
      border-radius: 8px;
    }
    .store-entrance {
      display: flex;
      align-items: center;
      font-size: 12px;
      color: #fff;
      z-index: 1;
      .arrow {
        margin-top: 2.5px;
        font-size: 16px;
        color: #fff;
      }
    }
    .store-detail {
      flex: 1;
      display: flex;
      overflow: hidden;
      z-index: 1;
      text-align: left;
      .store-logo {
        flex-grow: 0;
        flex-shrink: 0;
        width: 57.99px;
        height: 57.99px;
        border-radius: 8px;
      }
      .store-intro {
        width: 100%;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        margin-left: 8px;
        padding: 4px 0;
        color: #fff;
        .store-name {
          width: 56%;
          font-size: 18px;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }
        .sales-products-num {
          font-size: 12px;
          color: 13px;
          color: #fff;
          text-align: left;
        }
        .store-intro-top {
          flex: 1;
          display: flex;
          align-items: center;
          .country {
            display: flex;
            align-items: center;
            font-size: 12px;
            margin-left: 12px;
            img {
              margin-right: 5px;
            }
          }
        }
      }
    }
  }
}
</style>
